import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import SEO from "../../common-components/SEO";


export const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const sections = [
    {
      title: "Mission",
      text: "To inspire and empower students through a progressive, interdisciplinary curriculum that blends arts, engineering, and social sciences with real-world problem-solving. We aim to cultivate critical thinkers, ethical professionals, and socially responsible leaders ready to make a global impact.",
      img: "assets/images/about/about.webp",
      icon: "assets/images/about/target.webp",
    },
    {
      title: "Vision",
      text: "To be a world-class centre for architectural education, producing not just skilled architects but thoughtful, responsible citizens. At McGAN’S, learning goes beyond classrooms—preparing students to innovate, adapt, and transform society through architecture.",
      img: "assets/images/about/vision.webp",
      icon: "assets/images/about/eye.webp",
    },
    {
      title: "Our Philosophy",
      text: "At McGAN’S, we set high standards that challenge students while nurturing their artistic passion and professional excellence. We believe architecture and design can offer fulfillment to a diverse range of individuals, making it an accessible and rewarding field of study.",
      img: "assets/images/about/OurPhilosophy.webp",
      icon: "assets/images/about/philosphy.webp",
    },
    {
      title: "Faculty Practitioners",
      text: "At McGAN’S, our faculty comprises highly experienced practitioners who infuse real-world insights into the classroom. This approach ensures that students are well-prepared to navigate the evolving landscape of architecture and design.",
      img: "assets/images/about/g10.webp",
      icon: "assets/images/about/faculty.webp",
    },
    {
      title: "Location",
      text: "Located amidst the scenic beauty of Ooty, the campus provides an inspiring and creative environment for learning, exploration, and innovation in architecture and design.",
      img: "assets/images/about/location.webp",
      icon: "assets/images/about/locationicon.webp",
    },
    {
      title: "McGans World Record Event 2023 - 160 Artists, 160 Paintings, 160 Meters, 120 Minutes",
      text: "McGans World Record Event 2023 showcases 160 artists setting a world record by creating 160 stunning pictures of India's famous tourist spots in just 2 hours. These remarkable paintings are displayed on a 160-meter canvas and have gained international recognition, including a place in the India Book of Records.",
      img: "assets/images/about/worldrecord.webp"
    },
    {
      title: "Cultural fest",
      text: "Cultural Fest  was held in the presence of our honorable chairman Mr. N. Muralikumaran and actor/director Mr.Karu Pazhaniappan",
      img: "assets/images/about/culturefest.webp"
    },
    {
      title: "Campus visit and lecture talk",
      text: "Campus visit and lecture talk on the gateway to architecture and career options by Mr.Jayaprakash Gandhi was held on 28.04.2023 at our campus.",
      img: "assets/images/about/Campusvisit.webp"
    },
    {
      title: "ART EXHIBIT",
      text: "ART EXHIBIT| Students from all the batches displayed their art works today as part of the exhibition",
      img: "assets/images/about/art.webp"
    },
    {
      title: "Alumni meet",
      text: "Alumni meet  with the presence of honourable chairman Mr.N.Muralikumaran and chief guest Mr.Gobinath",
      img: "assets/images/about/Alumni meet.webp",

    },
    {
      title: "Heritage walk",
      text: "McGAN'S OOTY School of Architecture undertakes Ooty Heritage walk in collaboration with ICOMOS INDIA. The walk is part of the Heritage Club activity aimed to ensure that young architecture students remain motivated by the region's scenic architecture and cultural heritage. The walk is led by Associate Professor Ar. Shahzad Ahmed Malik accompanied by Associate Professor Ar. Vani Soundarya.",
      img: "assets/images/about/heriatage.webp"
    },
    {
      title: "Rural study",
      text: "Batch 2021 - II year undergoing rural study at Pollachi along with tutors Ar.Lokeshwar and Ar.Beena.",
      img: "assets/images/about/Ruralstudy.webp"
    },
    {
      title: "McGAN'S collabration with IIT CUBE",
      text: "The Mcgans Ooty School of Architecture's management and faculty extend their congratulations and best wishes to the fourth-year students, Darshan Kumar, Kirthik and Gokul on completing their IIT Madras CUBE Project Training successfully as a part of the MOU with IIT CUBE.",
      img: "assets/images/about/iit.webp"
    },
    {
      title: "Film set design workshop",
      text: "First year students involved in set design workshop by our principal Ar. Saravana Raja.",
      img: "assets/images/about/film.webp"
    },
    {
      title: "Urban Study",
      text: "Batch 2019 - IV year undergoing urban study at Mysore along with tutors Ar.Senthil Marthavanan and Ar.Kakoli.",
      img: "assets/images/about/urban.webp"
    },
    {
      title: "Outdoor sketching",
      text: "Batch 2022 students from outdoor sketching activity at the Ooty Botanical gardens.",
      img: "assets/images/about/out.webp"
    },
    {
      title: "McGAN'S teaching the tradition",
      text: "Batch 2021 experiencing the Hethai Amman festival, which is a traditional annual festival of badagas in Nilgiris.",
      img: "assets/images/about/trip.webp"
    }, {
      title: "Expression through colors workshop",
      text: "Expression through colours workshop for batch 2022 curated by Ar.Lokeshwar and Ar.Giridharan.",
      img: "assets/images/about/workshop.webp"
    },
    {
      title: "Film making workshop and campus visit of Director Kathir",
      text: `Film making workshop by Director Kadhir was conducted on 07.11.22 and 08.11.12.
The director wittnessed the potential of our students in architecture, while challenging them in film making aspects.`,
      img: "assets/images/about/vist.webp"
    },
    {
      title: "Halloween at McGAN'S",
      text: "First year students stepping into other realms with a Halloween themed face painting competition",
      img: "assets/images/about/hollven.webp"
    }, {
      title: "Architect Harsha Shivakumar visit to the campus",
      text: "Ar. Harsha Shivakumar, from Kumar and Swamy Architects, Bangalore visited McGANS Ooty School of Architecture on 13.09.2022 for a discussion regarding the Nilgiris Mountain Railway project, the methodology and way forward ",
      img: "assets/images/about/img1.webp"
    },
    {
      title: "Architect Soumitrao Ghosh visit to the college",
      text: "Ar. Soumitro Ghosh from Mathew and Ghosh Architects visited McGANS Ooty School of Architecture on 27.08.2022 for a discussion regarding the Nilgiris Mountain Railway project. Following this, he gave an insightful lecture on his eminent projects to our college students",
      img: "assets/images/about/img2.webp"
    },
    {
      title: "McGAN'S collabration with NMR",
      text: "Phase two of Nilgiri Mountain Railway docuntation was carried out by batch 2020 on 18th and 19th March 2022 assisted by Ar.Aruna Palanisami and Ar. Greeshma susan. A total of six stations were surveyed and documented as part of this program.",
      img: "assets/images/about/img3.webp"
    },
    {
      title: "Work - Life Balance",
      text: "'Work-Life Balance' Holi celebration highlights from McGans campus",
      img: "assets/images/about/img4.webp"
    },
    {
      title: "Discussion with CEPT Team",
      text: "We are extremely happy and thankful to the CEPT team for the 3 day long visit to the campus and for the interactive sessions with our faculty and students as part of the MoU program. CEPT expert team discussed on the proceedings of ongoing and upcoming modules to provide improved learning for the students of Mcgans. Student's from different semesters had an opportunity to exchange their ideas and discuss work in person with the expert team on communication English and foundation design studio.",
      img: "assets/images/about/img5.webp"
    },
    {
      title: "MoU with CEPT University",
      text: `CEPT University signs MoU with McGan’s Ooty School of Architecture Feb 28, 2021, 01.27 PM IST

On 27th Feb 2021, CEPT University signed a Memorandum of Understanding for a mentorship program with McGan’s Ooty School of Architecture, Ooty. Presided over by Chief Guest, Smt. Anju Sharma, Principal Secretary for Higher Education, the MoU is in line with the New Education Policy of the Government of India. It marks a new beginning for CEPT University, which is recognized nationally and internationally for its high-quality education, research and advisory work. Started in 1962 as School of Architecture, around the same time as the National Institute of Design (NID) and the Indian Institute of Management Ahmedabad (IIMA), CEPT has carved a niche for itself as a leading university focused on the disciplines of habitat.`,
      img: "assets/images/about/img6.webp"
    },
    {
      title: "MoA with IIT CUBE",
      text: "McGAN’S Ooty School of Architecture has signed a Memorandum of Agreement with CUBE – CENTRE FOR URBANIZATION, BUILDINGS AND ENVIRONMENT, IIT Madras which is declared as the centre for excellence by the Government of Tamil Nadu, to coordinate in the field of Research, Teaching, Professional development programs, development and implementation of research projects. The key focus of this collaboration is to bridge the gap between Academia, Research and Professional practice. The collaboration is to extend cooperation in various areas of interest including Green Buildings, Technical Advisory, Capacity Building and Environmental Sustainability utilizing CUBE’s industrial experience and McGAN’S technical skills in urban built environment. Also, this MoA paves way to jointly prepare proposals and maintain the exclusivity of the collaboration for the projects and their requirements.",
      img: "assets/images/about/img7.webp"
    },
    {
      title: "NEPCON-2021",
      text: "National Education Policy Conclave 2021@ McGAN’S Ooty, (NEPCON-2021)” held on 27th and 28th of March 2021, and making it a grand success. The conference deliberations were beyond fruitful and our contribution was unparallel",
      img: "assets/images/about/ne2.webp"
    }
  ];

  const IMAGE_DIMS = {
    "assets/images/about/about.webp": { width: 526, height: 378 },
    "assets/images/about/vision.webp": { width: 800, height: 600 },
    "assets/images/about/OurPhilosophy.webp": { width: 800, height: 600 },
    "assets/images/about/g10.webp": { width: 5760, height: 3840 },
    "assets/images/about/location.webp": { width: 826, height: 457 },
    "assets/images/about/worldrecord.webp": { width: 450, height: 400 },
    "assets/images/about/culturefest.webp": { width: 800, height: 600 },
    "assets/images/about/Campusvisit.webp": { width: 826, height: 457 },
    "assets/images/about/art.webp": { width: 799, height: 448 },
    "assets/images/about/Alumni meet.webp": { width: 858, height: 814 },
    "assets/images/about/heriatage.webp": { width: 800, height: 600 },
    "assets/images/about/Ruralstudy.webp": { width: 698, height: 771 },
    "assets/images/about/iit.webp": { width: 860, height: 686 },
    "assets/images/about/film.webp": { width: 791, height: 853 },
    "assets/images/about/urban.webp": { width: 781, height: 477 },
    "assets/images/about/out.webp": { width: 775, height: 824 },
    "assets/images/about/trip.webp": { width: 800, height: 600 },
    "assets/images/about/workshop.webp": { width: 800, height: 600 },
    "assets/images/about/vist.webp": { width: 800, height: 600 },
    "assets/images/about/hollven.webp": { width: 800, height: 600 },
    "assets/images/about/img1.webp": { width: 858, height: 814 },
    "assets/images/about/img2.webp": { width: 800, height: 600 },
    "assets/images/about/img3.webp": { width: 800, height: 600 },
    "assets/images/about/img4.webp": { width: 800, height: 600 },
    "assets/images/about/img5.webp": { width: 800, height: 600 },
    "assets/images/about/img6.webp": { width: 800, height: 600 },
    "assets/images/about/img7.webp": { width: 450, height: 450 },
    "assets/images/about/ne2.webp": { width: 800, height: 600 },
  };

  return (
    <>
      <SEO
        title="About Us"
        description="Learn about McGAN'S School of Architecture in Ooty - our mission, vision, philosophy, and campus life in the Nilgiris."
        keywords="About McGAN'S Ooty, Architecture College Mission, Vision of McGAN'S, Architecture Faculty Ooty, Campus Life Ooty"
        url="https://mcgansarch.com/about-us"
      />
      <h1 style={{ display: "none" }}>About McGAN'S Ooty School of Architecture</h1>
      {/* === Page Banner === */}
      <div className="page-banner-area bg-2">
        <div className="container">
          <div className="page-banner-content">
            <h3 className="BannerHeader">About Us</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="navspace">About Us</li>
            </ul>
          </div>
        </div>
      </div>

      {/* === Zig-Zag Section === */}
      <section className="zigzag-full">
        {sections.map((sec, i) => (
          <div
            key={i}
            className={`zigzag-row ${i % 2 === 0 ? "normal" : "reverse"}`}
            style={{ background: sec.bg, color: sec.textColor }}
            data-aos={i % 2 === 0 ? "fade-right" : "fade-left"}
          >
            <div className="zigzag-text" style={{ color: sec.textColor }}>
              <h3 style={{ color: sec.titleColor }}>{sec.title}</h3>
              <p>{sec.text}</p>
            </div>
            <div className="zigzag-img">
              <img
                src={sec.img}
                alt={sec.title}
                loading="lazy"
                width={IMAGE_DIMS[sec.img]?.width || 800}
                height={IMAGE_DIMS[sec.img]?.height || 600}
              />
            </div>
          </div>
        ))}
      </section>

    </>
  );
};
